import { useQuery } from "@tanstack/react-query";

import { loungesApi } from "api";
import { ApiQueryOptions } from "hooks/api/queryHelper";
import { AirportLounge, transformToAirportLoungeClass } from "models/AirportLounge";

const fetchAirportLounges = async (airportCode: string) => {
  const [error, response] = await loungesApi.fetchLounges(airportCode);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useFetchAirportLounges = (airportCode: string, options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: ["airportLounges", airportCode],
    queryFn: () => fetchAirportLounges(airportCode),
    select: (data) => data.map((airportLounge) => transformToAirportLoungeClass(airportLounge)) as AirportLounge[],
    ...options,
  });
};

export default useFetchAirportLounges;
